export default "__VITE_ASSET__C5zBEG0O__"